<dashboard-dialog-frame [header]="'Add a dashboard'" [dialogRef]='dialogRef' [actions]="actions">

	<div class='add-dashboard-dialog-content'>

		@if(service.currentStep() == 1) { <add-dashboard-step-1></add-dashboard-step-1> }
		@if(service.currentStep() == 2) { <add-dashboard-step-2></add-dashboard-step-2> }
		@if(service.currentStep() >= 3) { <add-dashboard-step-3></add-dashboard-step-3> }

	</div>


</dashboard-dialog-frame>